/* eslint-disable no-console */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useRef, useEffect } from 'react';
import { useGlobal, SelectCustom } from '@rcg/ui-react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Card,
  Divider,
  Grid,
  Typography,
} from '@material-ui/core';
import { Formik } from 'formik';
import { usePaymentInputs } from 'react-payment-inputs';
import MaskedInput from 'react-text-mask';
import images from 'react-payment-inputs/images';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import { formatPrice } from '@rcg/pricing-format';
import Tooltip from '../Tooltip';
import { CC_TYPE, SESSION_STORAGE_CURRENT_BOOKING } from '../../commons/constants';
import useStyles from '../MakePayment/index.style';
import TextField from '../TextField';
import Loader from '../Loader';
import { trackPaymentCTA } from '../../commons';
import theme from '../../theme/booking-theme';
import creditCardValidationSchema from './index.validation';
import { onlyLetters, getSessionStorageItem } from '../../commons/utils';
import { ReactComponent as CardIconFront } from '../../assets/svg/cc-illustration-fourCVV.svg';
import { ReactComponent as CardIconBack } from '../../assets/svg/cc-illustration-threeCVV.svg';

import creditCardStyles from './index.style';

const PayWithCreditCard = ({
  isMobile,
  paymentResult,
  paymentErrorInfo,
  price: { balanceDue, currencyCode },
  disableCreditCardForm,
  currentBalanceToPay,
  setHandleSubmit,
  setCreditCardData,
  setErrorCreditCard,
  affirmChecked,
  showCvvField,
}) => {
  const {
    renderContent,
    data: { localizedDayjs },
  } = useGlobal();
  const classes = useStyles();
  const classesCreditCard = creditCardStyles();
  const [payResponse, setPayResponse] = useState(balanceDue);
  const [showLoader, setShowLoader] = useState(false);
  const [month, setMonth] = React.useState('none');
  const [year, setYear] = React.useState('none');
  const [isExpanded, setIsExpanded] = useState(false);
  const [cvv, setCvv] = useState('');
  const [errorCvv, seterrorCvv] = useState(false);

  const creditCardRef = useRef(null);

  const ERROR_MESSAGES = {
    emptyCardNumber: renderContent(
      'bookingAmendCardNumberErrorRequired',
      'Card number is required',
    ),
    invalidCardNumber: renderContent(
      'bookingAmendPaymentCheckoutCardNumberErrorInvalid',
      'Card number is invalid',
    ),
  };
  const { meta, getCardNumberProps, getCardImageProps } = usePaymentInputs({
    errorMessages: ERROR_MESSAGES,
  });

  const cardNum = useRef(null);

  const cvvHandler = (event) => {
    const cvvRegex = /^\d{1,4}$/; // matches only numbers between 3-4 digits
    const { value } = event.target;
    if (cvvRegex.test(value) || value === '') {
      setCvv(value);
    }
    seterrorCvv(value.length < 3 || value.length > 4);
  };

  const placeholderStyle = theme.palette.grey8;
  const activeStyle = theme.palette.grey1;

  const cvvLabel = (
    <div className={classesCreditCard.tooltipContent}>
      <div className="icons-container">
        <div className="icon">
          <span>{renderContent('bookingAmendPaymentCvvHelperBack', 'Back')}</span>
          <CardIconBack />
        </div>
        <div className="icon">
          <span>{renderContent('bookingAmendPaymentCvvHelperFront', 'Front')}</span>
          <CardIconFront />
        </div>
      </div>
      <span>
        {renderContent('bookingAmendPaymentCvvHelper', '3 or 4 digit code found on your card')}
      </span>
    </div>
  );

  useEffect(() => {
    if (creditCardRef) {
      setHandleSubmit(creditCardRef);
    }
  }, [creditCardRef]);

  useEffect(() => {
    const currentBookingInfo = getSessionStorageItem(SESSION_STORAGE_CURRENT_BOOKING);

    if (paymentResult) {
      const { makePayment } = paymentResult;
      trackPaymentCTA(
        { amount: makePayment.paymentAmount, remainingBalance: makePayment.remainingBalance },
        '',
        'success',
        currentBookingInfo,
        CC_TYPE[meta?.cardType?.type],
      );
      setShowLoader(false);
      setPayResponse(makePayment.remainingBalance);
    }
    if (paymentErrorInfo) {
      trackPaymentCTA(
        { remainingBalance: paymentErrorInfo.remainingBalance, amount: paymentErrorInfo.amount },
        paymentErrorInfo,
        'error',
        currentBookingInfo,
        CC_TYPE[meta?.cardType?.type],
      );
      setShowLoader(false);
    }
  }, [paymentResult, paymentErrorInfo]);

  const years = Array.from({ length: 21 }, (v, index) => index + localizedDayjs().year()).map(
    (item) => {
      return { label: item, value: String(item) };
    },
  );

  const months = localizedDayjs
    .localeData()
    .monthsShort()
    .map((monthShort, i) => {
      return {
        label: monthShort,
        value: i < 9 ? `${0}${i + 1}` : `${i + 1}`,
      };
    });

  const placeHolderColor = (value) => {
    return value === '' ? placeholderStyle : activeStyle;
  };

  const handleFormChange = ({ card, errors }) => {
    const verifyCvv = showCvvField ? !errorCvv && cvv !== '' : true;
    const isFormWithOutError =
      !card.error &&
      Object.keys(errors).length === 0 &&
      year !== 'none' &&
      month !== 'none' &&
      verifyCvv;

    if (isFormWithOutError) {
      return setErrorCreditCard(false);
    }
    return setErrorCreditCard(true);
  };

  const handleExpand = () => {
    setIsExpanded(!isExpanded);
  };
  useEffect(() => {
    if (affirmChecked) {
      setIsExpanded(false);
    }
  }, [affirmChecked]);

  return (
    <Card className={classes.rootCard}>
      <Formik
        initialValues={{
          firstNameOnCard: '',
          lastNameOnCard: '',
          cardNumber: '',
          expiryMonth: '',
          expiryYear: '',
          cardType: '',
          paymentValue: '',
        }}
        validationSchema={creditCardValidationSchema(renderContent)}
        validate={(values) => {
          const errors = {};
          const onlyLettersRgx = /^[A-Za-z]+$/;

          const isFirstNameonCardError =
            values.firstNameOnCard &&
            (!onlyLettersRgx.test(values.firstNameOnCard) || values.firstNameOnCard.length > 14);

          const isLastNameOnCardError =
            values.lastNameOnCard &&
            (!onlyLettersRgx.test(values.lastNameOnCard) || values.lastNameOnCard.length > 19);

          if (isFirstNameonCardError) {
            errors.firstNameOnCard = renderContent(
              'bookingAmendPaymentFirstNameErrorInvalid',
              'Use up to 14 letters and no special characters',
            );
          }
          if (isLastNameOnCardError) {
            errors.lastNameOnCard = renderContent(
              'bookingAmendPaymentLastNameErrorInvalid',
              'Use up to 19 letters and no special characters',
            );
          }
          if (values.expiryMonth && values.expiryYear) {
            const position = values.expiryMonth - 1;
            const currentDate = new Date();
            const selectedDate = new Date();
            selectedDate.setMonth(position);
            selectedDate.setYear(values.expiryYear);
            if (selectedDate < currentDate) {
              errors.expiryMonth = renderContent(
                'bookingAmendPaymentExpirationDateErrorInvalid',
                'Invalid date',
              );
            } else {
              setMonth(values.expiryMonth);
              setYear(values.expiryYear);
            }
          }

          return errors;
        }}
        innerRef={creditCardRef}
        onSubmit={(values, actions) => {
          const amount = Number(currentBalanceToPay);
          const cardNumber = values.cardNumber.toString().replace(/\s/g, '');
          const cardType = CC_TYPE[meta.cardType.type];
          const expiration = `${values.expiryMonth}${values.expiryYear.slice(-2)}`;
          const variables = {
            variables: { ...values, amount, expiration, cardNumber, cardType, cvv },
          };
          setCreditCardData(variables);
          actions.resetForm();
          setMonth('none');
          setYear('none');
        }}>
        {({ errors, touched, values, handleSubmit, handleChange, handleBlur, setFieldValue }) => (
          <form
            onSubmit={handleSubmit}
            data-testid="form-credit-card"
            autoComplete="off"
            onFormChange={handleFormChange({ card: meta, errors, values })}>
            {payResponse > 0 && (
              <Accordion
                data-testid="accordion-creditCard-test"
                className={classes.Accordion}
                expanded={isExpanded}
                onChange={() => handleExpand()}>
                <AccordionSummary
                  expandIcon={isExpanded ? <RemoveIcon /> : <AddIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  disabled={affirmChecked}
                  className={classes.noStyleButton}>
                  <Typography className={classesCreditCard.creditCardTitle}>
                    {renderContent('formBookingAmendCreditCardTitle', 'Pay with credit card')}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Box>
                    {disableCreditCardForm ? (
                      <Typography className={classesCreditCard.totalPaymentsHaveBeenMet}>
                        {renderContent(
                          'bookingAmendPaymentTotalPaymentsHaveBeenMet',
                          'Your total amount has been met. Please continue with your payment.',
                        )}
                      </Typography>
                    ) : (
                      <>
                        <Typography className={classesCreditCard.creditCardSubtitle}>
                          {renderContent(
                            'formBookingAmendCreditCardSubTitle',
                            'Add your credit card information below to make a payment',
                          )}
                        </Typography>
                        <Divider />
                        <Typography className={classesCreditCard.creditCardBalanceCharged}>
                          {renderContent(
                            'formBookingAmendCreditCardBalanceCharged',
                            'Your credit card will be charged: ',
                          )}
                          {formatPrice(currentBalanceToPay, currencyCode, true, true, true)}
                        </Typography>
                        <Box className={classes.fieldsContainer}>
                          <Grid container>
                            <Grid container>
                              <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                                <MaskedInput
                                  mask={onlyLetters}
                                  data-testid="first-name-credit-card"
                                  label={renderContent(
                                    'formBookingAmendFieldFirstNameLabel',
                                    'First Name',
                                  )}
                                  placeholder={renderContent(
                                    'formBookingAmendFieldFirstNameLabel',
                                    'First Name',
                                  )}
                                  name="firstNameOnCard"
                                  onBlur={handleBlur}
                                  onChange={(event) =>
                                    setFieldValue('firstNameOnCard', event.target.value)
                                  }
                                  error={errors.firstNameOnCard && touched.firstNameOnCard}
                                  helperText={
                                    errors && touched.firstNameOnCard && errors.firstNameOnCard
                                  }
                                  value={values.firstNameOnCard}
                                  inputProps={{
                                    'data-testid': 'first-name-on-credit-card',
                                    className: `${classes.textFieldField}`,
                                  }}
                                  render={(ref, propsFirstName) => {
                                    return <TextField inputRef={ref} {...propsFirstName} />;
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                                <MaskedInput
                                  mask={onlyLetters}
                                  label={renderContent(
                                    'formBookingAmendFieldLastNameLabel',
                                    'Last name',
                                  )}
                                  placeholder={renderContent(
                                    'formBookingAmendFieldLastNameLabel',
                                    'Last name',
                                  )}
                                  name="lastNameOnCard"
                                  onBlur={handleBlur}
                                  onChange={(event) =>
                                    setFieldValue('lastNameOnCard', event.target.value)
                                  }
                                  error={errors.lastNameOnCard && touched.lastNameOnCard}
                                  helperText={
                                    errors && touched.lastNameOnCard && errors.lastNameOnCard
                                  }
                                  value={values.lastNameOnCard}
                                  inputProps={{
                                    'data-testid': 'last-name-on-credit-card',
                                    className: `${classes.textFieldField}`,
                                  }}
                                  render={(ref, propsLastName) => {
                                    return <TextField inputRef={ref} {...propsLastName} />;
                                  }}
                                />
                              </Grid>
                            </Grid>
                            <Grid container className={classes.rowContainer}>
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                md={6}
                                lg={6}
                                xl={4}
                                className="cardNumber">
                                <svg {...getCardImageProps({ images })} />
                                <TextField
                                  data-testid="cardNumber-payment"
                                  InputLabelProps={{ className: classes.styledLabel, shrink: true }}
                                  inputProps={{
                                    ...getCardNumberProps({
                                      onChange: handleChange,
                                      onBlur: handleBlur,
                                    }),
                                    placeholder: renderContent(
                                      'formBookingAmendFieldCreditCardPlaceholder',
                                      'Card number',
                                    ),
                                    maxLength: 19,
                                    'data-testid': 'card-number-payment',
                                    className: `${classes.textFieldField}`,
                                  }}
                                  inputRef={cardNum}
                                  label={renderContent(
                                    'paymentBookingAmendCardNumber',
                                    'Card Number',
                                  )}
                                  placeholder={renderContent(
                                    'formBookingAmendFieldCreditCardPlaceholder',
                                    'Card number',
                                  )}
                                  name="cardNumber"
                                  value={values.cardNumber}
                                  onChange={(event) =>
                                    setFieldValue('cardNumber', event.target.value)
                                  }
                                  error={
                                    (meta.touchedInputs.cardNumber &&
                                      typeof meta.erroredInputs.cardNumber !== 'undefined') ||
                                    (errors.cardNumber && touched.cardNumber)
                                  }
                                  helperText={
                                    (meta.touchedInputs.cardNumber &&
                                      meta.erroredInputs.cardNumber) ||
                                    (errors.cardNumber && touched.cardNumber)
                                  }
                                />
                              </Grid>
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                md={6}
                                lg={6}
                                xl={4}
                                className={classes.dateSelects}>
                                <SelectCustom
                                  isMobile={isMobile}
                                  selectLabel={renderContent(
                                    'paymentBookingPanelExpires',
                                    'Expiration date',
                                  )}
                                  placeholder={renderContent(
                                    'paymentBookingExpireMonthPlaceholder',
                                    'Month',
                                  )}
                                  options={months}
                                  inputProps={{ 'data-testid': 'expiration-month-payment' }}
                                  menuClassName={classes.selectMenu}
                                  defaultColor={placeHolderColor(values.expiryMonth)}
                                  handleOption={(event) =>
                                    setFieldValue('expiryMonth', event.target.value)
                                  }
                                  currentValue={values.expiryMonth || month}
                                  dataTestid="expiration-month-payment"
                                  textHelperError={
                                    errors.expiryMonth &&
                                    renderContent(
                                      'formBookingAmendRequiredExpireDate',
                                      'Invalid date',
                                    )
                                  }
                                />
                                <SelectCustom
                                  isMobile={isMobile}
                                  selectLabel="&nbsp;"
                                  placeholder={renderContent(
                                    'paymentBookingExpireYearPlaceholder',
                                    'Year',
                                  )}
                                  options={years}
                                  menuClassName={classes.selectMenu}
                                  defaultColor={placeHolderColor(values.expiryYear)}
                                  handleOption={(event) =>
                                    setFieldValue('expiryYear', event.target.value)
                                  }
                                  currentValue={values.expiryYear || year}
                                  inputProps={{ 'data-testid': 'expiration-year-payment' }}
                                  dataTestid="expiration-year-payment"
                                />
                                {showCvvField && (
                                  <div className={classesCreditCard.cvvtooltip}>
                                    <span className="tooltip-icon">
                                      <Tooltip title={cvvLabel} arrow placement="top" />
                                    </span>
                                    <TextField
                                      label={renderContent('bookingAmendPaymentCvvLabel', 'CVV')}
                                      name="cvv"
                                      value={cvv}
                                      onChange={cvvHandler}
                                      fullWidth
                                      error={errorCvv}
                                      placeholder={renderContent(
                                        'bookingAmendPaymentCvvLabel',
                                        'CVV',
                                      )}
                                      helperText={
                                        errorCvv &&
                                        renderContent(
                                          'bookingAmendPaymentCvvError',
                                          'CVV must be 3 or 4 digits',
                                        )
                                      }
                                      inputProps={{
                                        maxLength: 4,
                                        pattern: '[0-9]*',
                                        className: `${classes.textFieldField}`,
                                        'data-testid': 'cvv-payment',
                                      }}
                                    />
                                  </div>
                                )}
                              </Grid>
                            </Grid>
                          </Grid>
                        </Box>
                      </>
                    )}
                  </Box>
                </AccordionDetails>
              </Accordion>
            )}
          </form>
        )}
      </Formik>
      <Loader display={showLoader} />
    </Card>
  );
};

export default PayWithCreditCard;
